import App from '../../app';
import { Navigate, Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { AdminElement } from './components/admin-element/adminElement';
import { IndexElement } from './components/index-element/indexElement';
import { CompanyElement } from './components/company-element/companyElement';
import { NotFoundElement } from './components/not-found-element/notFoundElement';
import { AccessRequestElement } from './components/access-request-element/accessRequestElement';
import { StockDetail, StockForm, StockListLoader, TransformStockForm } from '../../modules/stock';
import { CategoryForm, CategoryListLoader, ImportPricesPanel, ProductDetailLoader, ProductFormLoader, ProductListLoader, ProductSettingsPanel } from '../../modules/products';
import { RoutePath } from './types';
import { StockAction } from '../ui';
import { IdElement } from './components/id-element/idElement';
import { InvoiceSaleOperationFormLoader, CreditAccountsPanelLoader, CreditPaymentDetail, TaxListLoader, TaxDetailLoader, CashFundFormLoader, CheckForm, CheckListLoader, CompanyPanel, EmployeeForm, EmployeeListLoader, TicketForm, ExpenseDetailLoader, ExpenseForm, ExpenseListLoader, ExpenseSupplierForm, ExpenseSupplierListLoader, ExpenseTypeForm, ExpenseTypeListLoader, PaymentTypeForm, PaymentTypeListLoader, SalaryDetailLoader, SalaryFormLoader, SalaryListLoader, TransferCashFundFormLoader, CheckDetailLoader, CreditCardForm, CreditCardDetailLoader, TaxForm, EmployeeDetailLoader, PendingPaymentListLoader, PaymentOrderFormLoader, TransactionList, PaymentOrderListLoader, TransactionDetail, PaymentOrderDetail, CashFundListLoader, EditCashFundAmountFormLoader, CreditCardListLoader, PaymentTypeDetailLoader, CreditPaymentFormLoader, CreditDebtsList } from '../../modules/administration';
import { BranchDetail, BranchList, RequestList } from '../../modules/manager';
import { PurchaseDetailLoader, PurchaseFormLoader, PurchaseListLoader, PurchasesSettingsPanel, SupplierForm, SupplierListLoader } from '../../modules/purchases';
import { BudgetDetailLoader, BudgetForm, BudgetListLoader, CustomerDetailLoader, CustomerForm, CustomerListLoader, CustomerTypeForm, CustomerTypeListLoader, HoardDetailLoader, HoardList, SaleDetailLoader, SaleFormLoader, SalesSettingsPanel, HoardFormLoader, IncreaseHoardFormLoader, ConfirmSalePaymentFormLoader, CustomerTypeDetailLoader, SaleList, ImportCustomerTypePanel, BulkConfirmPaymentsForm, ManualCreditNoteFormLoader } from '../../modules/sales';
import { UserPanel } from '../../modules/system';
import { TruckPreparationForm, ShipmentPreparationListLoader } from '../../modules/warehouse';
import { DriverForm, DriverListLoader, RoadmapDetailLoader, RoadmapFormLoader, RoadmapListLoader, VehicleDetailLoader, VehicleForm, VehicleListLoader, RoadmapShipmentPreparationDetail } from '../../modules/logistics';
import { DeliveryDataFormLoader, DeliveryOrderDetailLoader, EmitDeliveryOrderFormLoader, DeliveryFormLoader, CompleteDeliveryFormLoader, PickupOrderList, ShipmentOrderList, ReturnItemsFormLoader, CancelItemsFormLoader, ReceptionOrderList, DeliveryNoteList, DeliveryNoteDetailLoader } from '../../modules/deliveries';
import { DashboardPage } from '../../modules/dashboard';

export const Router = () => createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<App />}>
            <Route path="" element={<IndexElement />} />
            
            <Route path={RoutePath.ADMIN} element={<AdminElement />} />
            
            <Route path="/:companyCode" element={<CompanyElement />}>
                <Route path={RoutePath.ACCESS} element={<AccessRequestElement />} />

                <Route path={RoutePath.INICIO} element={<DashboardPage />} />

                <Route path={RoutePath.STOCK}>
                    <Route path="" element={<StockListLoader />} />
                    
                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<StockDetail />} />
                        <Route path={RoutePath.ADD} element={<StockForm />} />
                        <Route path={RoutePath.SUBSTRACT} element={<StockForm stockAction={StockAction.SUBSTRACT} />} />
                        <Route path={RoutePath.TRANSFORM} element={<TransformStockForm />} />
                    </Route>
                </Route>
               
                <Route path={RoutePath.PRODUCTS}>
                    <Route path="" element={<ProductListLoader />} />

                    <Route path={RoutePath.PRICES} element={<ImportPricesPanel />} />

                    <Route path={RoutePath.CREATE} element={<ProductFormLoader />} />
                    
                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<ProductDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<ProductFormLoader />} />
                    </Route>

                    <Route path={RoutePath.SETTINGS} element={<ProductSettingsPanel />} />
                </Route>

                <Route path={RoutePath.COMPANY} element={<CompanyPanel />} />

                <Route path={RoutePath.BRANCHES}>
                    <Route path="" element={<BranchList />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<BranchDetail />} />
                    </Route>
                </Route>

                <Route path={RoutePath.REQUESTS} element={<RequestList />} />

                <Route path={RoutePath.PENDING_PAYMENTS}>
                    <Route path="" element={<PendingPaymentListLoader />} />
                </Route>

                <Route path={RoutePath.PAYMENT_ORDERS}>
                    <Route path="" element={<PaymentOrderListLoader />} />

                    <Route path={RoutePath.CREATE} element={<PaymentOrderFormLoader />} />
                    
                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<PaymentOrderDetail />} />
                    </Route>
                </Route>

                <Route path={RoutePath.EMPLOYEES}>
                    <Route path="" element={<EmployeeListLoader />} />

                    <Route path={RoutePath.CREATE} element={<EmployeeForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<EmployeeDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<EmployeeForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.SALARIES}>
                    <Route path="" element={<SalaryListLoader />} />

                    <Route path={RoutePath.CREATE} element={<SalaryFormLoader />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<SalaryDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<SalaryFormLoader />} />
                    </Route>
                </Route>

                <Route path={RoutePath.CASH_FUNDS}>
                    <Route path="" element={<CashFundListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<CashFundFormLoader />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path={RoutePath.EDIT} element={<CashFundFormLoader />} />
                        <Route path={RoutePath.TRANSFER} element={<TransferCashFundFormLoader />} />
                        <Route path={RoutePath.ADD} element={<EditCashFundAmountFormLoader />} />
                        <Route path={RoutePath.SUBSTRACT} element={<EditCashFundAmountFormLoader />} />
                    </Route>
                </Route>

                <Route path={RoutePath.CHECKS}>
                    <Route path="" element={<CheckListLoader />} />

                    <Route path={RoutePath.CREATE} element={<CheckForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<CheckDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<CheckForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.CREDIT_CARDS}>
                    <Route path="" element={<CreditCardListLoader />} />

                    <Route path={RoutePath.CREATE} element={<CreditCardForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<CreditCardDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<CreditCardForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.TRANSACTIONS}>
                    <Route path="" element={<TransactionList />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<TransactionDetail />} />
                    </Route>
                </Route>

                <Route path={RoutePath.EXPENSES}>
                    <Route path="" element={<ExpenseListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<ExpenseForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<ExpenseDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<ExpenseForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.EXPENSE_TYPES}>
                    <Route path="" element={<ExpenseTypeListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<ExpenseTypeForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path={RoutePath.EDIT} element={<ExpenseTypeForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.EXPENSE_SUPPLIERS}>
                    <Route path="" element={<ExpenseSupplierListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<ExpenseSupplierForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path={RoutePath.EDIT} element={<ExpenseSupplierForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.PAYMENT_TYPES}>
                    <Route path="" element={<PaymentTypeListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<PaymentTypeForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<PaymentTypeDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<PaymentTypeForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.TAXES}>
                    <Route path="" element={<TaxListLoader />} />

                    <Route path={RoutePath.CREATE} element={<TaxForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<TaxDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<TaxForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.PURCHASES}>
                    <Route path="" element={<PurchaseListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<PurchaseFormLoader />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<PurchaseDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<PurchaseFormLoader />} />
                        <Route path={RoutePath.EDIT_DELIVERY_DATA} element={<DeliveryDataFormLoader />} />
                        
                        <Route path={RoutePath.TICKETS}>
                            <Route path={RoutePath.CREATE} element={<TicketForm />} />
                    
                            <Route path=":id" element={<IdElement />}>
                                <Route path={RoutePath.EDIT} element={<TicketForm />} />
                            </Route>
                        </Route>
                    </Route>

                    <Route path={RoutePath.SETTINGS} element={<PurchasesSettingsPanel />} />
                </Route>

                <Route path={RoutePath.SUPPLIERS}>
                    <Route path="" element={<SupplierListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<SupplierForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path={RoutePath.EDIT} element={<SupplierForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.BUDGETS}>
                    <Route path="" element={<BudgetListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<BudgetForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<BudgetDetailLoader />} />
                        <Route path={RoutePath.UPDATE} element={<BudgetForm />} />
                        <Route path={RoutePath.CREATE_SALE} element={<SaleFormLoader />} />
                        <Route path={RoutePath.CREATE_HOARD} element={<HoardFormLoader />} />
                    </Route>
                </Route>

                <Route path={RoutePath.SALES}>
                    <Route path="" element={<SaleList />} />
                    
                    <Route path={RoutePath.CREATE} element={<SaleFormLoader />} />
                    
                    <Route path={RoutePath.CONFIRM_PAYMENT} element={<BulkConfirmPaymentsForm />} />

                    <Route path={RoutePath.SETTINGS} element={<SalesSettingsPanel />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<SaleDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<SaleFormLoader />} />
                        <Route path={RoutePath.EDIT_DELIVERY_DATA} element={<DeliveryDataFormLoader />} />
                        <Route path={RoutePath.EMIT_DELIVERY} element={<EmitDeliveryOrderFormLoader />} />
                        <Route path={RoutePath.REGISTER_RETURN} element={<ReturnItemsFormLoader />} />
                        <Route path={RoutePath.CANCEL_ITEMS} element={<CancelItemsFormLoader />} />
                        <Route path={RoutePath.CONFIRM_PAYMENT} element={<ConfirmSalePaymentFormLoader />} />
                        <Route path={RoutePath.INVOICE} element={<InvoiceSaleOperationFormLoader />} />
                        <Route path={RoutePath.MANUAL_CREDIT_NOTE} element={<ManualCreditNoteFormLoader />} />
                    </Route>
                </Route>

                <Route path={RoutePath.HOARDS}>
                    <Route path="" element={<HoardList />} />
                    
                    <Route path={RoutePath.CREATE} element={<HoardFormLoader />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<HoardDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<HoardFormLoader />} />
                        <Route path={RoutePath.EDIT_DELIVERY_DATA} element={<DeliveryDataFormLoader />} />
                        <Route path={RoutePath.EMIT_DELIVERY} element={<EmitDeliveryOrderFormLoader />} />
                        <Route path={RoutePath.REGISTER_RETURN} element={<ReturnItemsFormLoader />} />
                        <Route path={RoutePath.CANCEL_ITEMS} element={<CancelItemsFormLoader />} />
                        <Route path={RoutePath.INCREASE_HOARD} element={<IncreaseHoardFormLoader />} />
                        <Route path={RoutePath.CONFIRM_PAYMENT} element={<ConfirmSalePaymentFormLoader />} />
                        <Route path={RoutePath.INVOICE} element={<InvoiceSaleOperationFormLoader />} />
                        <Route path={RoutePath.MANUAL_CREDIT_NOTE} element={<ManualCreditNoteFormLoader />} />
                    </Route>
                </Route>

                <Route path={RoutePath.CATEGORIES}>
                    <Route path="" element={<CategoryListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<CategoryForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path={RoutePath.EDIT} element={<CategoryForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.CUSTOMERS}>
                    <Route path="" element={<CustomerListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<CustomerForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<CustomerDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<CustomerForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.CREDIT_ACCOUNTS}>
                    <Route path="" element={<CreditAccountsPanelLoader />} />
                    
                    <Route path={RoutePath.DEBTS} element={<CreditDebtsList />} />
                    
                    <Route path=":id" element={<IdElement />}>
                        <Route path={RoutePath.CREATE} element={<CreditPaymentFormLoader />} />
                    </Route>
                </Route>

                <Route path={RoutePath.CREDIT_PAYMENTS}>
                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<CreditPaymentDetail />} />
                    </Route>
                </Route>

                <Route path={RoutePath.CUSTOMER_TYPES}>
                    <Route path="" element={<CustomerTypeListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<CustomerTypeForm />} />
                    <Route path={`${RoutePath.IMPORT}/:id?`} element={<ImportCustomerTypePanel />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<CustomerTypeDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<CustomerTypeForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.RECEPTION_ORDERS}>
                    <Route path="" element={<ReceptionOrderList />} />
                    
                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<DeliveryOrderDetailLoader />} />
                        <Route path={RoutePath.COMPLETE_DELIVERY} element={<DeliveryFormLoader />} />
                    </Route>
                </Route>

                <Route path={RoutePath.SHIPMENT_ORDERS}>
                    <Route path="" element={<ShipmentOrderList />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<DeliveryOrderDetailLoader />} />
                        <Route path={RoutePath.GENERATE_DELIVERY_NOTE} element={<DeliveryFormLoader />} />
                        <Route path={RoutePath.COMPLETE_DELIVERY} element={<CompleteDeliveryFormLoader />} />
                    </Route>
                </Route>

                <Route path={RoutePath.DELIVERY_NOTES}>
                    <Route path="" element={<DeliveryNoteList />} />
                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<DeliveryNoteDetailLoader />} />
                    </Route>
                </Route>

                <Route path={RoutePath.SHIPMENT_PREPARATION}>
                    <Route path="" element={<ShipmentPreparationListLoader />} />
                    <Route path=":id" element={<RoadmapShipmentPreparationDetail />} />
                </Route>

                <Route path={RoutePath.ROADMAPS}>
                    <Route path="" element={<RoadmapListLoader />} />
                    <Route path={RoutePath.CREATE} element={<RoadmapFormLoader />} />
                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<RoadmapDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<RoadmapFormLoader />} />
                        <Route path={RoutePath.PREPARE_TRUCK} element={<TruckPreparationForm />} />
                        <Route path={RoutePath.COMPLETE_DELIVERY} element={<CompleteDeliveryFormLoader />} />
                    </Route>
                </Route>

                <Route path={RoutePath.DRIVERS}>
                    <Route path="" element={<DriverListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<DriverForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path={RoutePath.EDIT} element={<DriverForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.VEHICLES}>
                    <Route path="" element={<VehicleListLoader />} />
                    
                    <Route path={RoutePath.CREATE} element={<VehicleForm />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<VehicleDetailLoader />} />
                        <Route path={RoutePath.EDIT} element={<VehicleForm />} />
                    </Route>
                </Route>

                <Route path={RoutePath.PICKUP_ORDERS}>
                    <Route path="" element={<PickupOrderList />} />

                    <Route path=":id" element={<IdElement />}>
                        <Route path="" element={<DeliveryOrderDetailLoader />} />
                        <Route path={RoutePath.COMPLETE_DELIVERY} element={<DeliveryFormLoader />} />
                    </Route>
                </Route>

                <Route path={RoutePath.USER} element={<UserPanel />} />
            </Route>
            
            <Route path={RoutePath.ERROR} element={<NotFoundElement />} />

            <Route path="*" element={<Navigate to={RoutePath.ERROR} />} />
        </Route>
    )
)
